const moment = require('moment');

moment.locale('fr');
moment.defineLocale('fr-FR', {
  parentLocale: 'fr',
  weekends: [0, 6],
  holidays: [
    // --- civil holidays ---
    '01-01', // new year's day
    '01-05', // labor day
    '08-05', // WWII victory day
    '14-07', // bastille day
    '11-11', // armistice day
    // --- religious holidays ---
    year => moment.easter(year).add(1, 'day'), // easter monday
    year => moment.easter(year).add(39, 'day'), // ascension day
    year => moment.easter(year).add(50, 'day'), // whit monday
    '15-08', // assumption of Mary
    '01-11', // all saint's day
    '25-12', // christmas
  ],
});
